import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KColorSwatch,
	KDataTable,
	KDataTableMenu
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default KDataTable.extend( {
	name: "KServiceTypesTable",

	mixins: [ Crudable ],

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no service statuses to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching service statuses found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "name"
		}
	},

	data: () => ( {
		crud: "services"
	} ),

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Status Name",
					value: "name"
				},
				{
					sortable: false,
					text: "Color",
					value: "color"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	methods: {
		deleteServiceType( serviceType ) {
			const deleteIndex = this.items.findIndex( item => serviceType.id === item.id );

			return serviceType.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.color": ( { item } ) =>
					<KColorSwatch
						color={item.color}
						selectable={false}
					></KColorSwatch>,

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "serviceType",
								params: { idServiceType: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							{this.canDelete && <KActionDialog
								confirmButtonColor="error"
								confirmButtonText="Delete"
								loading={this.$wait.is( "delete service type" )}
								onConfirm={() => this.deleteServiceType( item )}
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>delete</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>Delete</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								title="Delete Service Status"
							>
								Are you sure you want to delete the service status <strong>{item.name}</strong>?
							</KActionDialog>}
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			}}
		></KDataTable>;
	}
} );
